import { createContext } from 'react';
import styled from 'styled-components';

interface MenuProps<T> {
    value?: T;
    children: any;
    onChange?: (newValue: T) => void;

    isMultiple?: false;
}

interface MenuMultiProps<T> {
    value?: T[];
    children: any;
    onChange: (newValue: T[]) => void;

    isMultiple: true;
}

export const MenuContext = createContext({ test: 12, callback: (value: any) => { } });


export default function Menu<T>(props: MenuProps<T> | MenuMultiProps<T>) {

    return (
        <Wrapper >
            <MenuContext.Provider value={{ test: 1221, callback: (value: T | T[]) => props.isMultiple ? props.onChange(value as T[]) : props.onChange && props.onChange(value as T) }}>
                {props.children}
            </MenuContext.Provider>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    border-radius: ${props => props.theme.borderRadius};
    background-color: ${props => props.theme.backgroundColor};
    overflow: hidden;
`